import Home from "./pages/Home";
import Divider from "./components/Divider";
import Features from "./components/Features";
import OrderProcedures from "./components/OrderProcedures";
import About from "./pages/About";
import Services from "./components/Services";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="App">
      <Home />
      <Divider />
      <Features />
      <Divider />
      <About />
      <Divider />
      <OrderProcedures />
      <Divider />
      <Services />
      <Divider />
      <Footer />
    </div>
  );
}

export default App;